import { hasAnySubstring } from '../common/utils'
import { airbrakeNotify } from '../common/airbrake'
import { ajax } from '../common/ajax'
import Cookie from 'js-cookie'
import domready from 'domready'

const ONE_HOUR = 1 / 24

const SEARCH_ENGINES = [
  '.google.',
  '.yandex.',
  '.yahoo.',
  '.bing.',
  '.duckduckgo.',
  '.baidu.'
]

export function loadPhones() {
  const phones = sessionStorage.getItem('jensen_phones')

  if (phones) {
    populatePhones(JSON.parse(phones))
  } else {
    ajax({
      method: 'GET',
      url: process.env.JENSEN_SETTINGS_ENDPOINT + `?site_id=${JENSEN_SITE_ID}`,
      data: {},
      successCb (res) {
        sessionStorage.setItem('jensen_phones', JSON.stringify(res))
        populatePhones(res)
      },
      errorCb (xhr) { airbrakeNotify(`XHR Settings Error: ${xhr.statusText}`) }
    })
  }
}

function populatePhones(res) {
  if (res.phone_number && res.phone_number.value && res.phone_selector && resolvePhoneInsertion(res)) {
    domready(() => {
      const ph = res.pages_phone[location.pathname] || res.phone_number

      document.querySelectorAll(res.phone_selector).forEach(p => {
        p.innerHTML = ph.formatted_value
        const parentLink = p.closest('a[href^="tel:"]')
        if (parentLink) { processLink(parentLink, ph.value) }
      })

      document.querySelectorAll(res.phone_link_selector).forEach(p => processLink(p, ph.value))
    })
  }
}

function resolvePhoneInsertion(res) {
  const referrer = getReferrer()
  const type = res.phone_insertion

  if (type === 'never') return false
  if (type === 'always_on') return true
  if (type === 'direct_traffic' && (referrer === '' || referrer.indexOf(location.href) > -1)) return true
  if (type === 'referral_source' && !isSearchEngineReferrer(referrer) && isMarkedReferer(res, referrer)) return true

  return false
}

function getReferrer() {
  const referrer = Cookie.get('jensen_referrer')
  if (referrer) return referrer

  Cookie.set('jensen_referrer', document.referrer, { expires: ONE_HOUR })
  return document.referrer
}

function isSearchEngineReferrer(referrer) {
  return hasAnySubstring(referrer, SEARCH_ENGINES)
}

function isMarkedReferer(res, referrer) {
  return hasAnySubstring(referrer, res.referral_sources) || false
}

function processLink(link, phoneNumberValue) {
  link.href = 'tel:' + phoneNumberValue
}



// WEBPACK FOOTER //
// ./app/js/load_phones.js